import { CheckIcon } from "@heroicons/react/24/solid";
import { marcarNotificacionComoLeida } from "../../services/notificacion.service";
import { toast } from "react-toastify";

export const NotificationItem = ({ notification, onLeido }) => {
  const { id, mensaje, fecha, leido } = notification;

  const handleMarcarComoLeido = async () => {
    if (!leido) {
      try {
        await marcarNotificacionComoLeida(id);
        toast.success("Notificación marcada como leída");
        onLeido?.();
      } catch (error) {
        toast.error("Error al marcar como leída");
      }
    }
  };

  return (
    <div
      className={`group px-4 py-2 border-b transition-all duration-200 ${
        leido
          ? "bg-white text-gray-600"
          : "bg-blue-50 text-blue-800 font-semibold hover:bg-blue-100"
      }`}
    >
      <div className="flex justify-between items-center">
        <p className="text-sm">{mensaje}</p>
        {!leido && (
          <button
            onClick={handleMarcarComoLeido}
            className="text-blue-600 text-xs hover:underline flex items-center gap-1"
            title="Marcar como leído"
          >
            <CheckIcon className="w-4 h-4" />
          </button>
        )}
      </div>
      <p className="text-xs text-gray-400 mt-1">
        {new Date(fecha).toLocaleString()}
      </p>
    </div>
  );
};
